export default __webpack_public_path__ + "static/media/971.f64be030.png";